<template>
  <div class="esim-plus-wrap">
    <div class="box-1-wrap">
      <div class="box-1">
        <div class="introduce">
          <img
            src="~@/assets/esim-plus2/box1-img-2.png"
            alt
            class="box1-img-2"
          />
          <div class="text1">The Complete eSIM Solution</div>
          <div class="text2">
            Redtea Mobile offers the end-to-end eSIM solution – eSIM.plus.<br />
            eSIM.plus is the complete eSIM solution which includes GSMA SAS-SM
            certified Remote SIM Provisioning Platform (RSP) (SM-DP+),
            Entitlement Server (and Websheet server WS) for wearables and
            companion devices, carrier Apps for eSIM applications and
            enablement, and the eSIM SDK for M2M/IoT devices.
          </div>
          <div class="text3">
            eSIM.plus delivers a seamless digital experience with its eSIM
            plugins for Mobile operators.
          </div>
        </div>
        <img src="~@/assets/esim-plus2/box1-img-1.png" alt class="box1-img-1" />
        <div class="list">
          <a class="product-1" @click="scrollTo('#box-3')"
            >Remote SIM Provisioning Platform</a
          >
          <a class="product-2" @click="scrollTo('#box-6')"
            >Entitlement Server</a
          >
          <a class="product-3" @click="scrollTo('#box-7')"
            >eSIM Mobile Carrier APP</a
          >
          <a class="product-4" @click="scrollTo('#box-8')"
            >Internet of Things (IoT)</a
          >
        </div>
      </div>
    </div>
    <div class="box-2-wrap">
      <div class="box-2">
        <div class="text1">
          eSIM.plus Enables Mobile Operators to Onboard eSIM devices seamlessly
        </div>
        <div class="list">
          <div class="card-1">
            <img src="~@/assets/esim-plus2/box2-img-1.png" alt />
            <p class="introduce">APIs to connect consumer and IoT devices.</p>
          </div>
          <div class="card-2">
            <img src="~@/assets/esim-plus2/box2-img-2.png" alt />
            <p class="introduce">
              Configure primary and secondary devices <br />
              like smartwatches with eSIM profile.
            </p>
          </div>
          <div class="card-3">
            <img src="~@/assets/esim-plus2/box2-img-3.png" alt />
            <p class="introduce">
              Quick & easy onboarding of users with ready <br />
              to use Carrier App solution.
            </p>
          </div>
          <div class="card-4">
            <img src="~@/assets/esim-plus2/box2-img-4.png" alt />
            <p class="introduce">
              Option to deploy RSP and ES platform on-premises or as managed
              services model.
            </p>
          </div>
          <div class="card-5">
            <img src="~@/assets/esim-plus2/box2-img-5.png" alt />
            <p class="introduce">
              Digital eSIM experience to connect global <br />
              eSIM devices anytime, anywhere.
            </p>
          </div>
          <div class="card-6">
            <img src="~@/assets/esim-plus2/box2-img-6.png" alt />
            <p class="introduce">
              Technology experts for consulting <br />
              support and handholding during eSIM operations.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="box-3" id="box-3">
      <div class="box-wrap">
        <div class="box">
          <div class="text1">Remote SIM Provisioning Platform</div>
          <div class="text2">
            eSIM Plug-in for Mobile Operators available with SaaS and Managed
            Service Model
          </div>
        </div>
      </div>
      <div class="content-wrap">
        <div class="content">
          <img src="~@/assets/esim-plus2/box3-img-1.png" alt />
          <div class="list">
            <div class="title">HIGHLIGHTS</div>
            <ul>
              <li>
                <i class="icon"></i>
                <p class="introduce">GSMA SAS-SM Certified Platform.</p>
              </li>
              <li>
                <i class="icon"></i>
                <p class="introduce">
                  Integrates with simple API to your CRM system.
                </p>
              </li>
              <li>
                <i class="icon"></i>
                <p class="introduce">
                  Encapsulated with Entitlement & Websheet Server.
                </p>
              </li>
              <li>
                <i class="icon"></i>
                <p class="introduce">Highly Availability & Scalability.</p>
              </li>
              <li>
                <i class="icon"></i>
                <p class="introduce">Future Proof with updation like 5G.</p>
              </li>
              <li>
                <i class="icon"></i>
                <p class="introduce">
                  Supports Multiple Use Cases like GSMA Root DS, Carrier App.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="box-4-wrap">
      <div class="box-4">
        <div class="text1">Advantages of eSIM.plus RSP Platform</div>
        <div class="text2">
          eSIM.plus: Digital eSIM plug-in for Mobile Operators
        </div>
        <div class="card__outer">
          <div class="card">
            <div class="card-1">
              <img src="~@/assets/esim-plus2/box4-img-1.png" alt />
              <div class="title">Fast Time to Market</div>
              <div class="introduce">
                Extensive eSIM experience to launch eSIM service quickly and
                efficiently within a month.
              </div>
            </div>
            <div class="card-2">
              <img src="~@/assets/esim-plus2/box4-img-2.png" alt />
              <div class="title">End-to-End eSIM Support</div>
              <div class="introduce">
                Full eSIM lifecycle cases (activation, swap, termination, etc.)
              </div>
            </div>
            <div class="card-3">
              <img src="~@/assets/esim-plus2/box4-img-3.png" alt />
              <div class="title">Fully Digital Customer Experience</div>
              <div class="introduce">
                Create truly digital eSIM customer journey; Cut down the
                complexity of eSIM activation.
              </div>
            </div>
            <div class="card-4">
              <img src="~@/assets/esim-plus2/box4-img-4.png" alt />
              <div class="title">Reduced Risks</div>
              <div class="introduce">
                Follows the telecom level security checks and compliance with
                MNOs security guidelines.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-5-wrap">
      <div class="box-5">
        <div class="text1">eSIM Lifecycle Management on Your Fingertips</div>
        <div class="text2">
          Interactive eSIM Platform GUI for Mobile Operators
        </div>
        <div class="content">
          <img src="~@/assets/esim-plus2/box5-img-1.png" alt />
          <div class="card">
            <div class="card-1">
              <div class="top">
                <div class="left">Subscription Lifecycle</div>
                <div class="right">eSIM plan activation</div>
              </div>
              <div class="bottom">
                <li>POS store</li>
                <li>Call center</li>
                <li>Web selfcare</li>
                <li>Telco app</li>
              </div>
            </div>
            <div class="card-2">
              <div class="top">
                <div class="left">Swap Cases</div>
                <div class="right">Transfer eSIM profile between devices</div>
              </div>
              <div class="bottom">
                <li>Swap physical SIM to eSIM</li>
                <li>Switch eSIM device</li>
                <li>Repair eSIM device</li>
              </div>
            </div>
            <div class="card-3">
              <div class="top">
                <div class="left">Profile Mgt</div>
                <div class="right">Manage eSIM profile on the device</div>
              </div>
              <div class="bottom">
                <li>Enable eSIM profile on device</li>
                <li>Disable eSIM profile on device</li>
                <li>Delete eSIM profile on device</li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-6-wrap" id="box-6">
      <div class="box-6">
        <div class="text1">Entitlement Server</div>
        <div class="text2">
          The entitlement server ensures that the network supports all those
          features per the device's capability. These devices include mobile
          handsets for VoWifi, VoLTE-like network features, and companion
          devices like smartwatches and tablets to provide connectivity via
          eSIM. In addition, the Entitlement Server integrates Websheets for the
          end user onboarding and activation process.
        </div>
        <div class="text3">
          eSIM.plus Entitlement Server offers an enhanced user experience as per
          his device capabilities.
        </div>
        <div class="text4">
          <!-- <img src="~@/assets/" alt /> -->
          It offers additional revenue channels to mobile operators to connects
          different devices and offers them interactive subscription plans per
          user requirements.
        </div>
        <div class="text5">
          Real-life use cases like eSIM transfer are also critical and vital
          features of Entitlement Server to offer a seamless experience to the
          user. It is helpful if the user loses their device or wants to migrate
          from the old machine to the new one.
        </div>
        <div class="text6">
          Other feature like Multi-SIM (One Number) is widely used by most
          mobile operators where the handset and companion device, smartwatch,
          share the same mobile Number.
        </div>
        <Swiper class="server-swiper" :options="swiperOption">
          <SwiperSlide
            ><img src="~@/assets/esim-plus2/box6-img-1.png" alt
          /></SwiperSlide>
          <SwiperSlide
            ><img src="~@/assets/esim-plus2/box6-img-2.png" alt
          /></SwiperSlide>
          <SwiperSlide
            ><img src="~@/assets/esim-plus2/box6-img-3.png" alt
          /></SwiperSlide>
        </Swiper>
      </div>
    </div>
    <div class="box-7-wrap" id="box-7">
      <div class="box-7">
        <div class="text1">eSIM Mobile Carrier App is the New Shop</div>
        <div class="text2">
          The customer acquisition and conversion done fully in-app;
          Digital-Onboarding.
        </div>
        <div class="text3">
          eSIM activation immediately after customer order, no QR code required.
        </div>
        <div class="text4">
          Remove challenge for KYC & customer engagement via eKYC.
        </div>
        <div class="text5">
          Can be customised as per mobile operator’s business requirements.
        </div>
        <div class="card__outer">
          <div class="card">
            <div class="card-1">
              <img src="~@/assets/esim-plus2/box7-img-1.png" alt />
              <div class="number__outer">
                <div class="number">1</div>
              </div>
              <div class="description">
                Downloads Mobile Operators’ Self Care App from Store.
              </div>
            </div>
            <div class="card-2">
              <img src="~@/assets/esim-plus2/box7-img-2.png" alt />
              <div class="number__outer">
                <div class="number">2</div>
              </div>
              <div class="description">Complete Registration.</div>
            </div>
            <div class="card-3">
              <img src="~@/assets/esim-plus2/box7-img-3.png" alt />
              <div class="number__outer">
                <div class="number">3</div>
              </div>
              <div class="description">Selects the Subscription Plan.</div>
            </div>
            <div class="card-4">
              <img src="~@/assets/esim-plus2/box7-img-4.png" alt />
              <div class="number__outer">
                <div class="number">4</div>
              </div>
              <div class="description">Pay and Confirm for eSIM Download.</div>
            </div>
            <div class="card-5">
              <img src="~@/assets/esim-plus2/box7-img-5.png" alt />
              <div class="number">5</div>
              <div class="description">
                eSIM Downloaded and Connected to Network.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-8" id="box-8">
      <div class="box-8-wrap">
        <div class="box">
          <div class="text1">eSIM.plus IoT Solution</div>
          <div class="text2">Together We Can Support IoT</div>
        </div>
        <div class="content-wrap">
          <div class="content">
            <img src="~@/assets/esim-plus2/box8-img-1.png" alt />
            <div class="list">
              <div class="title">HIGHLIGHTS</div>
              <ul>
                <li>
                  <i class="icon"></i>
                  <p class="introduce">
                    <span>Future-Proof Technology</span>
                    : Based on the new GSMA eSIM architecture SGP.31 (IoT).
                  </p>
                </li>
                <li>
                  <i class="icon"></i>
                  <p class="introduce">
                    <span>Save on CAPEX</span>
                    : One investment in Remote SIM Provisioning for both
                    Consumer and IoT devices.
                  </p>
                </li>
                <li>
                  <i class="icon"></i>
                  <p class="introduce">
                    <span>Save on OPEX</span>
                    : No maintenance for unnecessary network elements, e.g.,
                    SM-DP & SM-SR.
                  </p>
                </li>
                <li>
                  <i class="icon"></i>
                  <p class="introduce">
                    <span>Adopt with Turnkey Solution</span>
                    : Extensive Solution and Software deliverable upon request
                    for device management and remote configuration, e.g., TR069.
                  </p>
                </li>
                <li>
                  <i class="icon"></i>
                  <p class="introduce">
                    <span>Develop your IoT Ecosystem</span>
                    : With eSIM.plus, you can leverage the ODM/OEM chain
                    advantage with a rich stock of numerous device makers.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-9-wrap">
      <div class="box-9">
        <div class="text1">eSIM.plus IoT Solution Components</div>
        <div class="card__outer">
          <div class="card">
            <div class="card-1">
              <img src="~@/assets/esim-plus2/box9-img-1.png" alt />
              <div class="title">eSIM APIs</div>
              <div class="description">
                API-based eSIM as a service, making cellular connectivity
                programmable following GSMA-accredited RSP <br />( remote SIM
                provisioning ).
              </div>
            </div>
            <div class="card-2">
              <img src="~@/assets/esim-plus2/box9-img-2.png" alt />
              <div class="title">Portable IPA SDK</div>
              <div class="description">
                IPA ( IoT profile assistant ) is provided <br />
                in the SDK, supporting Linux, <br />
                RTOS, and Android, enabling easy integration for various device
                form <br />
                factors.
              </div>
            </div>
            <div class="card-3">
              <img src="~@/assets/esim-plus2/box9-img-3.png" alt />
              <div class="title">GSMA Compliant eUICC</div>
              <div class="description">
                GSMA-compliant eUICC chip for <br />
                secure profile hosting and switching <br />
                capability.
              </div>
            </div>
            <div class="card-4">
              <img src="~@/assets/esim-plus2/box9-img-4.png" alt />
              <div class="title">Bootstrap Connectivity</div>
              <div class="description">
                Comes with Initial connectivity - <br />
                Bootstrap to download operational <br />
                profiles when the device powered on.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact-wrap">
      <!-- <img src="~@/assets/esim-plus2/contact.png" alt class="bg" /> -->
      <div class="contact">
        <div class="text1">Launch Your eSIM Services Today with eSIM.plus</div>
        <div class="contact-button" @click="openDialog">Contact us</div>
      </div>
    </div>
    <Modal
      v-model="model"
      mask-closable
      :mask="true"
      class="contact-dialog"
      width="820"
    >
      <template #close>
        <Icon type="md-close" class="close" @click="closeDialog" />
      </template>
      <template #header>
        <div class="title">Contact us</div>
      </template>
      <p class="foot-desc">
        Fill and submit the form or Whatsapp/Call on this number: +65 6631 8453
      </p>
      <div class="form">
        <Form
          ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate"
          label-position="top"
        >
          <div style="width: 100%; margin-bottom: 10px">
            <FormItem
              label="Full Name"
              prop="name"
              style="
                width: 100%;
                max-width: 315px;
                margin-right: 20px;
                display: inline-block;
              "
            >
              <Input
                v-model="formValidate.name"
                placeholder="First Name and Last Name"
              ></Input>
            </FormItem>
            <FormItem
              label="Business Email"
              prop="mail"
              style="width: 100%; max-width: 343px; display: inline-block"
            >
              <Input v-model="formValidate.mail" clearable></Input>
            </FormItem>
          </div>
          <FormItem
            label="Company Name"
            prop="company"
            style="width: 100%; max-width: 440px"
          >
            <Input v-model="formValidate.company" clearable></Input>
          </FormItem>
          <FormItem label="Interested In" prop="domain" style="width: 100%">
            <Select
              v-model="formValidate.domain"
              placeholder="Select the Solution"
              clearable
            >
              <Option
                :value="item"
                v-for="(item, index) in cpu_domainSelectOptions"
                :key="index"
                >{{ item }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="Country or Region" prop="region" style="width: 100%">
            <Select
              v-model="formValidate.region"
              placeholder="Select the Country or Region"
              clearable
            >
              <Option
                :value="item.value"
                v-for="(item, index) in cpu_regionSelectOptions"
                :key="index"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="Your Message" prop="message" class="textarea">
            <Input v-model="formValidate.message" type="textarea"></Input>
          </FormItem>
        </Form>
      </div>
      <!--      <div class="policy">-->
      <!--        <Checkbox v-model="isAgreePrivacy" />-->
      <!--        I agree to the-->
      <!--        <a href="https://redteago.com/privacy-policy" target="_blank">*privacy policy*</a>-->
      <!--      </div>-->
      <template #footer>
        <div
          class="submit"
          :class="{ 'submit--disabled': !isAgreePrivacy }"
          @click="submitDialog"
        >
          Submit
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import {
  COUNTRY_SELECT_OPTION,
  DOMAIN_SELECT_OPTION_EN,
  DOMAIN_SELECT_OPTION_ZH,
} from "../utils/index.js";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  components: { Swiper, SwiperSlide },
  data() {
    return {
      model: false,
      disabledSubmitForm: false,
      formValidate: {
        name: "",
        mail: "",
        region: "",
        domain: "",
        company: "",
        message: "",
      },
      isAgreePrivacy: false,
      ruleValidate: {
        name: [
          {
            required: true,
            message: "Required",
            trigger: "blur",
          },
        ],
        mail: [
          {
            required: true,
            message: "Required",
            trigger: "blur",
          },
          { type: "email", message: "Incorrect email format", trigger: "blur" },
        ],
      },
      swiperOption: {
        initialSlide: 1,
        slidesPerView: "auto",
        centeredSlides: true, // active居中
        spaceBetween: 14,
      },
    };
  },
  computed: {
    cpu_domainSelectOptions() {
      const locale = this.$i18n.locale;
      switch (locale) {
        case "zh":
          return DOMAIN_SELECT_OPTION_ZH;
        default:
          return DOMAIN_SELECT_OPTION_EN;
      }
    },
    cpu_regionSelectOptions() {
      const locale = this.$i18n.locale;
      switch (locale) {
        case "zh":
          return COUNTRY_SELECT_OPTION.map((item) => ({
            value: item.value,
            label: item.label,
          }));
        default:
          return COUNTRY_SELECT_OPTION.map((item) => ({
            value: item.value,
            label: item.value,
          }));
      }
    },
  },
  methods: {
    scrollTo(elSelector) {
      const el = document.querySelector(elSelector);
      if (el) {
        // 会被header挡住，手动带上偏移量来滚动
        document.documentElement.scrollTo(0, el.offsetTop - 100);
      }
    },
    openDialog() {
      this.model = true;
    },
    closeDialog() {
      this.model = false;
    },
    submitDialog() {
      if (!this.isAgreePrivacy) return;
      if (this.disabledSubmitForm) return;
      this.$refs["formValidate"].validate(async (valid) => {
        if (valid) {
          try {
            this.disabledSubmitForm = true;
            await this.$api.api.enquiry({
              name: this.formValidate.name,
              businessEmail: this.formValidate.mail,
              company: this.formValidate.company,
              domain: this.formValidate.domain,
              region: this.formValidate.region,
              help: this.formValidate.message,
              site: 2,
            });
            this.disabledSubmitForm = false;
            this.$Message.success({
              content: "Submitted successfully",
              duration: 2,
            });
            this.formValidate.name = "";
            this.formValidate.mail = "";
            this.formValidate.company = "";
            this.formValidate.domain = "";
            this.formValidate.region = "";
            this.formValidate.message = "";
            this.isAgreePrivacy = false;
          } catch (error) {
            this.disabledSubmitForm = false;
            this.$Message.error("Fail");
            this.formValidate.name = "";
            this.formValidate.mail = "";
            this.formValidate.company = "";
            this.formValidate.domain = "";
            this.formValidate.region = "";
            this.formValidate.message = "";
          }
        } else {
        }
      });
    },
  },
};
</script>
<style lang="less">
.ivu-form-item-label {
  font-size: 16px;
  font-family: Poppins-Medium, Poppins;
  font-weight: 500;
  color: #1b2456;
  line-height: 16px;
}
.ivu-select-selection {
  padding-left: 20px;
  height: 52px !important;
  line-height: 52px !important;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #ebedf0 !important;
}
.ivu-select-placeholder {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #b6b7bb;
  height: 52px !important;
  line-height: 52px !important;
}
.ivu-select-selected-value {
  height: 52px !important;
  line-height: 52px !important;
}
.ivu-input::placeholder {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #b6b7bb;
  line-height: 22px;
}
.ivu-input {
  padding-left: 20px;
  height: 52px;
  background: #ffffff;
  border-radius: 8px !important;
  border: 1px solid #ebedf0 !important;
}
.textarea .ivu-input {
  height: 10em;
  background: #ffffff;
  border-radius: 8px !important;
  border: 1px solid #ebedf0 !important;
}
.ivu-modal-footer,
.ivu-modal-header {
  padding: 30px 32px 48px 40px;
  border: 0;
}
.ivu-modal-footer {
  padding-top: 0;
}
.ivu-modal-header {
  padding-bottom: 0;
}
.ivu-modal-content {
  border-radius: 12px;
}
.ivu-modal-close {
  top: 34px;
  right: 33px;
}
.contact-dialog {
  box-shadow: 0px 4px 64px 0px rgba(0, 0, 0, 0.06);
  background: #ffffff;
  .close {
    color: #1b2456;
    font-size: 26px;
  }
  .title {
    font-size: 24px;
    font-family: Poppins-SemiBold, Poppins;
    font-weight: 600;
    color: #1b2456;
    line-height: 36px;
    text-align: center;
    padding-bottom: 1.25em;
  }
  .ivu-modal-body {
    padding: 0 32px 0 40px;
  }
  .policy {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1b2456;
    line-height: 16px;
    text-align: center;
    padding-bottom: 36px;
    a {
      color: #1e2480;
      text-decoration: underline;
    }
  }
  .submit {
    width: 100%;
    max-width: 565px;
    height: 52px;
    background: #1e2480;
    border-radius: 12px;
    line-height: 52px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    cursor: pointer;
    user-select: none;
    margin: 0 auto;
    &.submit--disabled {
      background: #666bb4;
      cursor: not-allowed;
    }
  }
  .foot-desc {
    margin-top: 0;
    margin-bottom: 2.5em;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    color: #1b2456;
  }
}
</style>
<style lang="less" scoped>
.esim-plus-wrap {
  text-align: left;
  width: 100%;
  &::before {
    content: "";
    display: block;
    padding-top: 0.66rem;
  }
  .box-1-wrap {
    background: url(~@/assets/esim-plus2/box1-bg.png) no-repeat;
    background-size: cover;
    width: 100%;
    .box-1 {
      max-width: calc(1200px + 0.5rem);
      margin: 0 auto;
      position: relative;
      padding-right: 0.25rem;
      padding-left: 0.25rem;
      overflow: hidden;
      .box1-img-1 {
        width: 100%;
        margin-top: 28px;
      }
      .box1-img-2 {
        display: block;
        width: 270px;
        height: 48px;
        margin: 0 auto;
      }
      .introduce {
        padding-top: 28px;
        .text1 {
          margin-top: 0.1rem;
          font-size: 32px;
          font-family: Poppins-Bold, Poppins;
          font-weight: bold;
          color: #52afff;
          line-height: 1.2em;
          text-align: center;
        }
        .text2,
        .text3 {
          font-size: 16px;
          font-family: Poppins-Light, Poppins;
          font-weight: 300;
          color: #ffffff;
          line-height: 24px;
          padding-top: 16px;
        }
        .text3 {
          padding-top: 0;
        }
      }
      .list {
        width: 100%;
        margin-top: 28px;
        margin-bottom: 28px;
        display: flex;
        flex-direction: column;
        a {
          display: block;
          list-style: none;
          box-sizing: border-box;
          box-sizing: border-box;
          font-family: Poppins-Medium, Poppins;
          padding: 0.1rem;
          text-align: center;
          background: #1e2480;
          border-radius: 4px;
          color: #ffffff;
          border: 1px solid rgba(255, 255, 255, 0.5);
          transition: background 0.25s;
          &:active {
            background: #4b74fb;
          }
        }
        a + a {
          margin-top: 0.1rem;
        }
      }
    }
  }
  .box-2-wrap {
    background: #f6f6f9;
    width: 100%;
    .box-2 {
      max-width: 1440px;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      .text1 {
        font-size: 24px;
        font-family: Poppins-Bold, Poppins;
        font-weight: bold;
        color: #1a2356;
        line-height: 36px;
        margin-top: 28px;
        margin-bottom: 28px;
        text-align: center;
      }
      .list {
        display: flex;
        flex-direction: column;
        padding-right: 0.25rem;
        padding-left: 0.25rem;
        margin-top: 28px;
        margin-bottom: 28px;
        div {
          font-size: 14px;
          .introduce {
            font-family: Poppins-Regular, Poppins;
            font-weight: 400;
            color: #1b2456;
            line-height: 24px;
            padding-top: 0.5em;
          }
          &.card-1 {
            img {
              width: 34px;
            }
          }
          &.card-2 {
            img {
              width: 73px;
            }
          }
          &.card-3 {
            img {
              width: 42px;
            }
          }
          &.card-4 {
            img {
              width: 85px;
            }
          }
          &.card-5 {
            img {
              width: 40px;
            }
          }
          &.card-6 {
            img {
              width: 60px;
            }
          }
        }
        > div + div {
          margin-top: 2em;
        }
      }
    }
  }
  .box-3 {
    .box-wrap {
      background: #ffffff;
      width: 100%;
      .box {
        max-width: 1440px;
        padding-right: 0.25rem;
        padding-left: 0.25rem;
        margin: 0 auto;
        position: relative;
        overflow: hidden;
        .text1 {
          margin-top: 28px;
          margin-bottom: 28px;
          font-size: 24px;
          font-family: Poppins-Bold, Poppins;
          font-weight: bold;
          color: #1b2456;
          text-align: center;
        }
        .text2 {
          margin-top: 28px;
          margin-bottom: 28px;
          font-size: 14px;
          font-family: Poppins-Regular, Poppins;
          font-weight: 400;
          color: #1b2456;
          line-height: 24px;
          text-align: center;
        }
      }
    }
    .content-wrap {
      background: #222f88;
      width: 100%;
      .content {
        max-width: calc(1200px + 0.5rem);
        margin: 0 auto;
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 28px 0.25rem;
        img {
          width: 100%;
          max-width: 600px;
        }
        .list {
          .title {
            font-size: 16px;
            font-family: Poppins-Bold, Poppins;
            font-weight: bold;
            color: #ffffff;
            line-height: 36px;
            padding-top: 28px;
            padding-bottom: 1em;
          }
          ul {
            li {
              list-style: none;
              position: relative;
              i {
                position: absolute;
                width: 16px;
                top: 0;
                transform: translateY(20%);
                left: 0;
                height: 16px;
                background: url(~@/assets/esim-plus2/icon-1.png) no-repeat;
                background-size: 100% 100%;
              }
              p {
                padding-left: 36px;
                font-size: 16px;
                font-family: Poppins-Regular, Poppins;
                font-weight: 400;
                color: #ffffff;
              }
            }
            li + li {
              margin-top: 1em;
            }
          }
        }
      }
    }
  }
  .box-4-wrap {
    background: #ffffff;
    width: 100%;
    .box-4 {
      max-width: calc(1200px + 0.5rem);
      padding-right: 0.25rem;
      padding-left: 0.25rem;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      .text1 {
        margin-top: 28px;
        margin-bottom: 28px;
        text-align: center;
        font-size: 24px;
        font-family: Poppins-Bold, Poppins;
        font-weight: bold;
        color: #1b2456;
      }
      .text2 {
        margin-top: 28px;
        margin-bottom: 28px;
        text-align: center;
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #1b2456;
      }
    }
    .card__outer {
      margin-top: 28px;
      margin-bottom: 28px;
      // overflow-y: hidden;
      overflow-x: auto;
    }
    .card {
      display: flex;
      flex-wrap: nowrap;
      .card-1,
      .card-2,
      .card-3,
      .card-4 {
        flex-shrink: 0;
        max-width: 288px;
        padding: 0.25rem;
        background: #ffffff;
        box-shadow: 0px 1px 46px 0px rgba(0, 0, 0, 0.04);
        border-radius: 16px;
        border: 1px solid rgba(21, 27, 57, 0.08);
        box-sizing: border-box;
        img {
          width: 40px;
        }
        .title {
          font-size: 16px;
          font-family: Poppins-Bold, Poppins;
          font-weight: bold;
          color: #1b2456;
          line-height: 24px;
          padding-top: 24px;
          padding-bottom: 32px;
        }
      }
      .card-2 {
        .title {
          padding-right: 49px;
          padding-bottom: 8px;
        }
      }
      .card-3 {
        .title {
          padding-right: 45px;
          padding-bottom: 8px;
        }
      }
      > div + div {
        margin-left: 0.1rem;
      }
    }
  }
  .box-5-wrap {
    background: #f6f6f9;
    width: 100%;
    .box-5 {
      max-width: calc(1200px + 0.5rem);
      padding-right: 0.25rem;
      padding-left: 0.25rem;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      .text1 {
        margin-top: 28px;
        margin-bottom: 28px;
        font-size: 24px;
        font-family: Poppins-Bold, Poppins;
        font-weight: bold;
        color: #1b2456;
        text-align: center;
      }
      .text2 {
        margin-top: 28px;
        margin-bottom: 28px;
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #1b2456;
        text-align: center;
      }
      .content {
        display: flex;
        flex-direction: column;
        margin-top: 28px;
        margin-bottom: 28px;
        align-items: center;
        justify-content: space-between;
        img {
          width: 100%;
          max-width: 677px;
        }
      }
      .card {
        margin-top: 28px;
        .card-1,
        .card-2,
        .card-3 {
          // width: 415px;
          background: #ffffff;
          border-radius: 16px;
          .top {
            background: #1b2456;
            box-shadow: 0px 1px 46px 0px rgba(0, 0, 0, 0.04);
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            width: 100%;
            padding: 0.1rem 0.2rem;
            .left {
              font-size: 14px;
              font-family: Poppins-Bold, Poppins;
              font-weight: bold;
              color: #ffffff;
              line-height: 21px;
              margin-right: 20px;
            }
            .right {
              font-size: 14px;
              font-family: Poppins-Regular, Poppins;
              font-weight: 400;
              color: #ffffff;
              line-height: 21px;
            }
          }
          .bottom {
            color: #1b2456;
            li {
              list-style: none;
              position: relative;
              padding-left: 16px;
              &::before {
                content: "";
                position: absolute;
                left: 0;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background: #1b2456;
                top: 50%;
                transform: translateY(-50%);
              }
            }
          }
        }
        .card-1 {
          margin-bottom: 14px;
          .bottom {
            display: flex;
            flex-wrap: wrap;
            padding: 0.2rem;
            justify-content: space-between;
            li {
              width: 50%;
              list-style: none;
            }
          }
        }
        .card-2 {
          margin-bottom: 14px;
          .bottom {
            padding: 0.2rem;
          }
        }
        .card-3 {
          .bottom {
            padding: 0.2rem;
          }
        }
      }
    }
  }
  .box-6-wrap {
    background: linear-gradient(
      to bottom,
      #222f88,
      #222f88 calc(100% - 30vw),
      #ffffff calc(100% - 30vw),
      #ffffff
    );
    width: 100%;
    .box-6 {
      max-width: 1440px;
      margin: 0 auto;
      position: relative;
      .text1 {
        font-size: 24px;
        font-family: Poppins-Bold, Poppins;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
        padding-top: 28px;
        padding-bottom: 28px;
      }
      .text2 {
        max-width: calc(1200px + 0.5rem);
        padding: 0 0.25rem;
        margin: 0 auto;
        font-size: 14px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #eaebf3;
      }
      .text3 {
        max-width: calc(1200px + 0.5rem);
        padding: 0 0.25rem;
        margin: 0 auto;
        font-size: 14px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #eaebf3;
      }
      .text4 {
        max-width: calc(1200px + 0.5rem);
        padding: 2em 0.25rem 0 0.25rem;
        margin: 0 auto 16px auto;
        font-size: 14px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #eaebf3;
        position: relative;
        &::before {
          content: "";
          display: block;
          width: 34px;
          height: 34px;
          margin-bottom: 0.75em;
          background: url("~@/assets/esim-plus2/icon-2.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .text5 {
        max-width: calc(1200px + 0.5rem);
        padding: 0 0.25rem 0 0.25rem;
        margin: 0 auto 16px auto;
        font-size: 14px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #eaebf3;
        position: relative;
        &::before {
          content: "";
          display: block;
          width: 34px;
          height: 34px;
          margin-bottom: 0.75em;
          background: url("~@/assets/esim-plus2/icon-2.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .text6 {
        max-width: calc(1200px + 0.5rem);
        padding: 0 0.25rem 0 0.25rem;
        margin: 0 auto 32px auto;
        font-size: 14px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #eaebf3;
        position: relative;
        &::before {
          content: "";
          display: block;
          width: 34px;
          height: 34px;
          margin-bottom: 0.75em;
          background: url("~@/assets/esim-plus2/icon-2.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .server-swiper {
        // overflow: initial;
        .swiper-slide {
          width: 80vw !important;
          transform-origin: right center;
          transform: scale(0.9);
          transition: transform 0.25s;
          img {
            border-radius: 8px;
          }
        }
        .swiper-slide-active {
          transform-origin: initial;
          transform: scale(1);
          & + .swiper-slide {
            transform-origin: left center;
          }
        }
      }
    }
  }
  .box-7-wrap {
    background: #ffffff;
    width: 100%;
    .box-7 {
      max-width: calc(1200px + 0.5rem);
      padding-right: 0.25rem;
      padding-left: 0.25rem;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      .text1 {
        margin-top: 56px;
        margin-bottom: 28px;
        font-size: 24px;
        font-family: Poppins-Bold, Poppins;
        font-weight: bold;
        color: #1b2456;
        text-align: center;
      }
      .text2 {
        margin-bottom: 1em;
        padding-left: 26px;
        font-size: 14px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #1b2456;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          width: 16px;
          height: 16px;
          top: 2px;
          background: url("~@/assets/esim-plus2/icon-1.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .text3 {
        margin-bottom: 1em;
        padding-left: 26px;
        font-size: 14px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #1b2456;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          width: 16px;
          height: 16px;
          top: 2px;
          background: url("~@/assets/esim-plus2/icon-1.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .text4 {
        margin-bottom: 1em;
        padding-left: 26px;
        font-size: 14px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #1b2456;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          width: 16px;
          height: 16px;
          top: 2px;
          background: url("~@/assets/esim-plus2/icon-1.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .text5 {
        margin-bottom: 2em;
        padding-left: 26px;
        font-size: 14px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #1b2456;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          width: 16px;
          height: 16px;
          top: 2px;
          background: url("~@/assets/esim-plus2/icon-1.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .card__outer {
        margin-top: 28px;
        margin-bottom: 28px;
        overflow-x: auto;
      }
      .card {
        display: flex;
        flex-wrap: nowrap;
        position: relative;
        .card-1,
        .card-2,
        .card-3,
        .card-4,
        .card-5 {
          flex-shrink: 0;
          text-align: left;
          width: 228px;
          img {
            width: 100%;
          }
          .number__outer {
            position: relative;
            &::after {
              content: "";
              position: absolute;
              top: 50%;
              left: 50%;
              width: calc(100% + 1em);
              border: 1px dashed rgba(27, 36, 86, 0.35);
            }
          }
          .number {
            border-radius: 50%;
            width: 24px;
            height: 24px;
            background: #1e2480;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
            line-height: 22px;
            margin: 33px auto 20px;
            text-align: center;
            line-height: 24px;
            position: relative;
            z-index: 1000;
          }
          .description {
            font-size: 14px;
            font-family: Poppins-Regular, Poppins;
            font-weight: 400;
            color: #1b2456;
            line-height: 21px;
          }
        }
        > div + div {
          margin-left: 1em;
        }
      }
    }
  }
  .box-8 {
    .box-8-wrap {
      background: #f6f6f9;
      width: 100%;
      .box {
        max-width: 1440px;
        margin: 0 auto;
        position: relative;
        overflow: hidden;
        .text1 {
          margin-top: 28px;
          margin-bottom: 28px;
          font-size: 24px;
          font-family: Poppins-Bold, Poppins;
          font-weight: bold;
          color: #1b2456;
          text-align: center;
        }
        .text2 {
          margin-top: 28px;
          margin-bottom: 28px;
          font-size: 14px;
          font-family: Poppins-Medium, Poppins;
          font-weight: 500;
          color: #1b2456;
          text-align: center;
        }
      }
      .content-wrap {
        background: #222f88;
        width: 100%;
        .content {
          max-width: calc(1200px + 0.5rem);
          padding: 28px 0.25rem;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            width: 100%;
            max-width: 676px;
          }
          .list {
            margin-top: 28px;
            .title {
              font-size: 16px;
              font-family: Poppins-Bold, Poppins;
              font-weight: bold;
              color: #ffffff;
              margin-bottom: 1em;
            }
            ul {
              font-size: 14px;
              li {
                position: relative;
                list-style: none;
                i {
                  position: absolute;
                  width: 16px;
                  top: 4px;
                  left: 0;
                  height: 16px;
                  background: url(~@/assets/esim-plus2/icon-1.png) no-repeat;
                  background-size: 100% 100%;
                }
                p {
                  padding-left: 36px;
                  font-family: Poppins-Regular, Poppins;
                  font-weight: 400;
                  color: #ffffff;
                  span {
                    font-family: Poppins-Bold, Poppins;
                  }
                }
              }
              li + li {
                margin-top: 1em;
              }
            }
          }
        }
      }
    }
  }
  .box-9-wrap {
    background: #ffffff;
    width: 100%;
    .box-9 {
      max-width: calc(1200px + 0.5rem);
      padding-right: 0.25rem;
      padding-left: 0.25rem;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      .text1 {
        margin-top: 28px;
        margin-bottom: 28px;
        font-size: 24px;
        font-family: Poppins-Bold, Poppins;
        font-weight: bold;
        color: #1b2456;
        text-align: center;
      }
      .card__outer {
        margin-top: 28px;
        margin-bottom: 28px;
        overflow-x: auto;
      }
      .card {
        display: flex;
        flex-wrap: nowrap;
        .card-1,
        .card-2,
        .card-3,
        .card-4 {
          flex-shrink: 0;
          max-width: 288px;
          img {
            width: 100%;
          }
          .title {
            margin-top: 1em;
            margin-bottom: 1em;
            font-size: 16px;
            font-family: Poppins-Bold, Poppins;
            font-weight: bold;
            color: #1b2456;
          }
          .description {
            font-size: 14px;
            font-family: Poppins-Regular, Poppins;
            font-weight: 400;
            color: #1b2456;
            line-height: 21px;
          }
        }
        > div + div {
          margin-left: 1em;
        }
      }
    }
  }
  .contact-wrap {
    position: relative;
    width: 100%;
    background: url("~@/assets/esim-plus2/contact.png"), #151b39;
    background-size: cover;
    background-position: right bottom;
    // .bg {
    //   width: 100%;
    //   display: block;
    // }
    .contact {
      padding-right: 0.25rem;
      padding-left: 0.25rem;
      text-align: center;
      overflow: hidden;
      .text1 {
        margin-top: 28px;
        margin-bottom: 28px;
        font-size: 20px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
      }
      .contact-button {
        max-width: 150px;
        padding-right: 0.25rem;
        padding-left: 0.25rem;
        border-radius: 34px;
        border: 1px solid #ffffff;
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #ffffff;
        line-height: 3;
        letter-spacing: 1px;
        text-align: center;
        margin: 28px auto;
        cursor: pointer;
        user-select: none;
        transition: background 0.25s, border-color 0.25s;
        &:active {
          border-color: #4b74fb;
          background-color: #4b74fb;
        }
      }
    }
  }
}
</style>